import React,{useState,useEffect}  from 'react';
import "./HotelView.css";
import heroImg from "../../assets/Hotel.jpg";
import prevIcon from "../../assets/icons/PrevIcon.svg";
import searchIcon from "../../assets/icons/Search.svg";
import hotelService from "../../assets/Hotels/hotelService.png";
import cab from "../../assets/Hotels/cab.png";
import houseKeping from "../../assets/Hotels/houseKeeping.png";
import foodService from "../../assets/Hotels/foodService.png";
import resturentBooking from "../../assets/Hotels/roomBooking.png";
import spa from "../../assets/Hotels/spa.png";
import wifi from "../../assets/Hotels/wifi.png";
import wakeUpCall from "../../assets/Hotels/wakeUp.png";
import custom from "../../assets/Hotels/custom.png";
import roomChange from "../../assets/Hotels/roomChange.png";
import lateCheckoutImg from "../../assets/Hotels/checkInRequest.png";
import conferenceRoom from "../../assets/Hotels/conference.png"
import useAuth from "../../customHooks/useAuth.js";
import axios from 'axios';
import {useNavigate,useLocation,useParams} from "react-router-dom";
import { toast } from 'react-toastify';
import PageLoader from '../../assets/pageLoader/PageLoader.js';
import { baseUrl } from '../../common/baseUrl';
import bykelogo from "../../assets/LobbyByke.webp"
import axiosInstance from '../../axiosInstance/axiosInstance';
import { isServiceSupported, loadBookingContext } from '../../common/bookingContext';
import { getImageUrl, peekImageUrl } from '../../common/imageUrl';


export default function HotelView() {

  const navigate = useNavigate();
  const location = useLocation();

  const { bookingId } = useParams();

  const [booking,setBooking] = useState(null);

  const booking_id = bookingId;
  const hotel_id = booking?.hotelId || "";
  const hotelName = booking?.hotelName || "";
  const hotelAddress = booking?.hotelAddress || "";
  const checkInDate = booking?.checkInDate || "";
  const checkOutDate = booking?.checkOutDate || "";
  const status = booking?.status || "";
  const bookingCode = booking?.booking_code || "";

  // Which tab to drop back onto in /bookings. Purely cosmetic, so it stays in
  // navigation state rather than the URL.
  const activeTab = location.state?.activeTab || "";

  const userId = localStorage.getItem("user_id");

  const [pageLoad,setPageLoad] = useState(false);
  // Comes from the fetched booking so it survives a refresh, a deep link, or a
  // return trip from web check-in, none of which carry navigation state. The
  // state value is only a head start while the booking is still loading.
  const imageKey = booking?.landingPhoto || location.state?.landing_photo || "";


  // Refresh Handle
  useAuth();

  // Landing Photo. Seeded from the cache — the bookings list prefetches this
  // very photo when it renders the card — so arriving from a card paints the
  // hotel's own image rather than the default one.
  const [landingPhoto, setLandingPhoto] = useState(() => peekImageUrl(imageKey) || heroImg);

  useEffect(() => {
    let isCancelled = false;

    // No image key → use default image
    if (!imageKey) {
      setLandingPhoto(heroImg);
      return;
    }

    const cached = peekImageUrl(imageKey);

    if (cached) {
      setLandingPhoto(cached);
      return;
    }

    getImageUrl(imageKey)
      .then((url) => {
        if (!isCancelled && url) {
          setLandingPhoto(url);
        }
      })
      .catch((error) => {
        console.log("Error loading landing photo:", error);

        if (!isCancelled) {
          setLandingPhoto(heroImg);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [imageKey]);



  // The booking is the page, so it is read from the URL and fetched here
  // instead of being handed over in navigation state.
  useEffect(() => {
    let isCancelled = false;

    const loadBooking = async () => {
      try{
        setPageLoad(true);
        const context = await loadBookingContext(bookingId);

        if(!isCancelled){
          setBooking(context);
        }
      }catch(error){
        console.log(error);
        if(!isCancelled){
          navigate("/bookings");
        }
      }
      finally{
        if(!isCancelled){
          setPageLoad(false);
        }
      }
    };

    loadBooking();

    return () => {
      isCancelled = true;
    };
  },[bookingId,navigate]);


  // Opens one of the request forms under this booking
  const goToService = (service) => {
    navigate(`/bookings/${bookingId}/requests/new/${service}`,{state : {activeTab : activeTab}});
  };


  // WebCheckin Tags
  const [selectedTags,setSelectedTags] = useState({});
  const [arrivalTime,setArrivalTime] = useState(""); // Expected arrival time saved on the web checkin


  // For Guide Lines
  const [guideLoad,setGuideLoad] = useState(false); // Hotel Guidelines Request
  const [guideLinesData,setGuideLinesData] = useState([]);


  const [guests,setGuests] = useState([]);
  const [bookedRooms, setBookedRooms] = useState([]); // for all those require rooms

  
  // PreCheckIn Requests
  const [dataLoaded, setDataLoaded] = useState(false); // Flag to ensure data is loaded for WebCheckIn



  // Hotel Guide Lines
  useEffect(()=>{
    if(guideLoad){
      navigate("/hotelGuidelines",{state : {
        bookingId : booking_id,
        hotelId : hotel_id,
        hotelName : hotelName,
        hotelAddress : hotelAddress,
        checkInDate : checkInDate,
        checkOutDate : checkOutDate,
        status : status,
        activeTab : activeTab,
        Data : guideLinesData,
        booking_code : bookingCode
      }})
    }

  },[guideLoad,booking_id,hotel_id,hotelAddress,hotelName,checkInDate,checkOutDate,navigate,status,activeTab,guideLinesData]);



  // Get The Web CheckIn Requests For The Rooms 
  const fetchRequests = async (roomIDs) => {
    
    const promises = roomIDs.map(async (roomId) => {
      try {
        // Attempt to make the request for the current roomId
        const response = await axiosInstance.get(`/api/v1/hotels/${hotel_id}/bookings/${booking_id}/booked-rooms/${roomId}/guest-requests/web-checkin`);
 
        return { roomId, webCheckIn_status: true };
 
      } catch (error) {
        console.log("Here Error",error);
        return { roomId, webCheckIn_status: false};
        
      }
    });
  
  
    const results = await Promise.all(promises);
  
    return results;
  };
  

  // PreCheckIn Requests
  
  // WebCheckIn
  useEffect(() => {
    if (dataLoaded) {
      // Navigate only after data is loaded and state is updated
      navigate("/webCheckIn", {
        state: {
          bookingId: booking_id,
          hotelId: hotel_id,
          hotelName : hotelName,
          hotelAddress : hotelAddress,
          checkInDate: checkInDate,
          checkOutDate: checkOutDate,
          status : status,
          activeTab : activeTab,
          bookedRooms: bookedRooms,
          guests: guests,
          selectedTags: selectedTags,
          timeArrival: arrivalTime,
        }
      });
    }
  }, [dataLoaded, guests, bookedRooms, booking_id, hotel_id, checkInDate, checkOutDate, navigate,status,activeTab,hotelAddress,hotelName,selectedTags,arrivalTime]);

  // BackButtton
  const handleClick = ()=>{
    navigate("/bookings",{state : {bookingsNav : "bookings",activeTab : activeTab}});
  }


  
  const handleWebCheckIn = async () => {
    try {
      setPageLoad(true);

      // The support check and the check-in itself only need ids we already
      // have, so they go out together instead of one behind the other.
      const [supported, response] = await Promise.all([
        isServiceSupported(hotel_id, "Web Checkin"),
        axiosInstance.get(`/api/v1/users/${userId}/bookings/${booking_id}/web-checkin`),
      ]);

      if (!supported) {
        toast.error("Your Hotel Does Not Support Web Checkin Request Service");
        return;
      }

      const webCheckinData = response.data;
      if (!webCheckinData) {
        setBookedRooms([]);
        setGuests([]);
        setDataLoaded(true);
        return;
      }

      // Rooms returned from new API
      const rooms = (webCheckinData.rooms || []).map((room) => ({
        ...room,
        webCheckIn_status: webCheckinData.status,
        webCheckIn_time_status: room.is_checkin_completed,
      }));

      setBookedRooms(rooms);

      // Guests for each room
      const guests = (webCheckinData.rooms || []).map(
        (room) => room.guests || []
      );

      const formattedData = {
        "Purpose of stay": webCheckinData.purpose || [],
        "Travelling with": webCheckinData.travelling_with || [],
        "Dietary preferences": webCheckinData.dietary || [],
        "Arrival preference": webCheckinData.arrival ? [webCheckinData.arrival] : [],
        "Interests during stay": webCheckinData.interests || [],
      };
      console.log("Format Data :",formattedData);

      setSelectedTags(formattedData);
      setArrivalTime(webCheckinData.arrival_time || "");
      setGuests(guests);
      setDataLoaded(true);

    } catch (error) {
      console.error(error);
    } finally {
      setPageLoad(false);
    }
  };


  const handleWebCheckInOld = async () => {
    try {
 
      try{
        const response2 = await axiosInstance.get(`/api/v1/hotels/${hotel_id}/services`);

        const hotelServicesData = response2.data.data;
   
        if (Array.isArray(hotelServicesData)) {
          const serviceFound = hotelServicesData.find(service => service.name === "Web Checkin");
          if(serviceFound) {
            console.log("Service Found : ",serviceFound);
          }
          else{  
            toast.error("Your Hotel Does Not Support Web Checkin Request Service")
            return;
          }
        } else {
          console.log("Error: hotelServicesData is not an array", hotelServicesData);
        } 
      }catch(error){
        console.log(error);
      }

      setPageLoad(true);



      const response = await axiosInstance.get(
        `/api/v1/hotels/${hotel_id}/bookings/${booking_id}/booked-rooms`
      );

      const data = response.data.data;
 
      const getBookedRoomIds = data.map((room)=>{
        return room.id;
      })
 
      const allRequests = await fetchRequests(getBookedRoomIds);
 

      const updatedRoomsData = data.map((roomData) => {
          // Find the corresponding request based on the room's id
          const findRequest = allRequests.find((request) => request.roomId === roomData.id);
          
          if (findRequest) {
            // If a matching request is found, return the updated room data with the webCheckIn_status
            return { ...roomData, webCheckIn_status: findRequest.webCheckIn_status,webCheckIn_time_status : false };
          }          return roomData;
          
      });

 
 
      setBookedRooms(updatedRoomsData);

      // Initialize the guests array based on the number of booked rooms
      const initializedGuests = data.map(() => []); 
      // Create an empty array for each booked room
 
      setGuests(initializedGuests);

      // Set flag indicating data has been fully loaded
      setDataLoaded(true);

    } catch (error) {
      console.log(error);
    }
    finally{
      setPageLoad(false);
    }
  };

  // Early CheckIn
  // Post CheckIn Requests


 

  // Taxi Request
  // HouseKeeping Request
  // Resturent Booking Request
  // Wake Up Call Request
  // roomChangeRequest
  // Custom Request
  // Conference Room Request
  // Late Checkout Request
  // wifi Request
  // CheckOut Request
 
  // Hotel Guidelines Request
  const hotelGuidelines = async()=>{
    try{
      const response = await axiosInstance.get(`/api/v1/hotels/${hotel_id}`);

      setGuideLinesData(response.data);
      setGuideLoad(true);

      setPageLoad(true);

    }catch(error){
      console.log(error);
    }
    finally{
      setPageLoad(false);
    }
  }


  return (
      
    <div className='hotel-view'>


      {pageLoad && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999 // Make sure the loader is on top
        }}>
          <PageLoader/>
        </div>
      )}


      {/* Hero Section */}
      <div className='hotel-hero' style={{ backgroundImage: `url(${landingPhoto})` }}>
        <div className='hotel-hero-content'>
            <div className='prev-icon'>
              <img src={prevIcon} onClick={handleClick} alt="" />
            </div>
            <div className='hotel-hero-data'>
                <h3 onClick={hotelGuidelines}>
                   {hotelName}
                </h3>
                <p>
                  {hotelAddress && hotelAddress.length>10  ? hotelAddress.slice(0,15) + "..." : hotelAddress}
                </p>
            </div>
            <div className='search-icon'>
              <img src={searchIcon} alt="" />
            </div>
        </div>
      </div>

      {bookingCode && (
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <p>Invite Code : <b>{bookingCode}</b></p>
        </div>
      )}

      
      {/* Services Section */}
      {status==="UPCOMING" && 
        <div className='hotel-services' >
        <div className='service' onClick={handleWebCheckIn}>
          <div className='service-img'>
            <img src={hotelService} alt="" /> 
          </div>
          <span>Web-Check-In</span>
        </div>
        
        <div className='service' onClick={()=>goToService("early-checkin")}>
          <div className='service-img'>
            <img src={hotelService} alt="" /> 
          </div>
          <span>Early-Check-In</span>
        </div>

        <div className='service' onClick={()=>goToService("cab")}>
          <div className='service-img'>
            <img src={cab} alt="" /> 
          </div>
          <span>Cab</span>
        </div>
        </div>
      }
      {status==="ONGOING" && 
        //  Request 
        <>
          <div className='hotel-services' >

            <div className='service'  onClick={()=>goToService("housekeeping")}>
              <div className='service-img'>
                <img src={houseKeping} alt="" /> 
              </div>
              <span>Housekeeping</span>
            </div>
            
            {/* Food Request */}
            <div className='service' onClick={()=>goToService("food")}>
              <div className='service-img'>
                <img src={foodService} alt="" /> 
              </div>
              <span>Food</span>
            </div>

            {/* Taxi */}
            <div className='service' onClick={()=>goToService("taxi")}>
              <div className='service-img'>
                <img src={cab} alt="" /> 
              </div>
              <span>Taxi</span>
            </div>

            {/* Spa */}
            <div className='service' onClick={()=>goToService("spa")}>
              <div className='service-img'>
                <img src={spa} alt="" /> 
              </div>
              <span>Spa</span>
            </div>

            {/* restuarant  Booking */}
            <div className='service'  onClick={()=>goToService("table-booking")}>
              <div className='service-img'>
                <img src={resturentBooking} alt="" /> 
              </div>
              <span>Restaurant Booking</span>
            </div>

            {/* Wake Up Call */}
            <div className='service' onClick={()=>goToService("wakeup-call")} >
              <div className='service-img'>
                <img src={wakeUpCall} alt="" /> 
              </div>
              <span>WakeUpCall</span>
            </div>
            
            {/* Wifi */}
            <div className='service' onClick={()=>goToService("wifi")}>
              <div className='service-img'>
                <img src={wifi} alt="" /> 
              </div>
              <span>WiFi</span>
            </div>

            {/* Custom Request */}
            <div className='service' onClick={()=>goToService("custom")} >
              <div className='service-img'>
                <img src={custom} alt="" /> 
              </div>
              <span>Custom</span>
            </div>

            {/* Room Change */}
            <div className='service' onClick={()=>goToService("room-change")}>
              <div className='service-img'>
                <img src={roomChange} alt="" /> 
              </div>
              <span>Room Change</span>
            </div>

            {/* Late Checkout */}
            <div className='service' onClick={()=>goToService("late-checkout")} >
              <div className='service-img'>
                <img src={lateCheckoutImg} alt="" />
              </div>
              <span>Late Checkout</span>
            </div>

            {/* Conference Stay  */}
            <div className='service' onClick={()=>goToService("conference-room")} >
              <div className='service-img'>
                <img src={conferenceRoom} alt="" /> 
              </div>
              <span>Conference Room</span>
            </div>

            {/* checkOut */}
            <div className='service' onClick={()=>goToService("checkout")} >
              <div className='service-img'>
                <img src={hotelService} alt="" /> 
              </div>
              <span>Checkout</span>
            </div>
  
          </div>
        </>
      }

    </div>
  );
}
